import React from 'react';
import { Link } from 'react-router-dom';

import Button from '../helpers/Button';

import PayImg from '../../images/pay.svg';

const Pay = ({ isMenuOpen }) => {
  return (
    <div
      className={`bg-cf-100 py-20 lg:pl-48 lg:pr-20 ${
        isMenuOpen ? 'pl-14 pr-2 md:pl-48 md:pr-8' : 'px-4 md:px-8'
      }`}
    >
      <div className="container mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 md:gap-6 lg:gap-8">
          <div className="mb-8 md:mb-0">
            <h3 className="font-bold text-xl mb-6">Total Wallet</h3>
            <ul className="flex text-center">
              <li className="pr-3 lg:pr-6 font-bold text-base lg:text-lg">
                GHS 20,000 <span className="block text-sm font-normal">Amount in wallet</span>
              </li>
              <li className="pr-3 lg:pr-6 font-bold text-base lg:text-lg">
                GHS 5,000 <span className="block text-sm font-normal">Wallet used</span>
              </li>
              <li className="font-bold text-base lg:text-lg">
                GHS 15,000 <span className="block text-sm font-normal">Wallet balance</span>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-xl mb-6">Pay with wallet</h3>
            <div className="w-full lg:w-115 bg-white rounded shadow-cfw">
              <div className="flex flex-wrap items-center justify-between">
                <div className="flex items-center px-4">
                  <div className="mr-3">
                    <img className="h-8" src={PayImg} alt="PayImg" />
                  </div>
                  <p className="font-bold">
                    You can buy a farm <br className="block lg:hidden" />
                    using your wallet{' '}
                    <Link to="/start-farm" className="block text-sm text-green-600 font-normal">
                      Start A Farm
                    </Link>
                  </p>
                </div>
                <Button
                  name="Buy"
                  className="bg-cf-300 px-6 py-8 font-bold text-white rounded-tr rounded-br shadow-cfw"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Pay;
